<!--template>
  <div>
      <center><h1 style="font-size:150px">{{position}}</h1></center>
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import utils from '@/services/utils'
  import io from "socket.io-client"
  export default {
    props: {
      data: {
        type: Object,
        required: true,
        default: null
      },
    },
    data: () => ({
      position: null
    }),
    computed: {
      ...mapState('app',['locale', 'FontContent', 'FontSizeContent', 'ColorContent']),
    },
    created() {
      this.socket = io("https://qmanager.dviewcontent.com");
    },
    mounted () {
        this.socket.on("position", data => {
          this.position = data
      })
    },
  }
</script-->
<template>
  <div>
    <div
      class="text-center" 
      v-if="loading"
      style="padding: 20px;"
    >
      <v-progress-circular
        :size="50"
        :width="7"
        :color="BGColor"
        indeterminate
        style="opacity: 0.5;"
      />
    </div>
    <iframe
      id="iframeCustom"
      v-if="url"
      :src="url"
      height="760"
      frameborder="0"
      width="100%"
      seamless="seamless"
      @load="handleLoadComplete"
      v-show="!loading"
    />
  </div>
</template>

 <script>
  import constants from '@/constants'
  import _ from 'lodash'
  export default {
    props: {
      data: {
        type: Object,
        required: true,
        default: null,
      },
    },
    data: () => ({
      loading: true,
      url: null,
    }),
    computed: {
      BGColor () {
        return this.$store.state.app.BGColor
      },
      isSimulation () {
        return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
    },
    watch: {
      'data.QueueID' () {
        this.url = `https://widgets.dviewcontent.com/queue/pharmacy/?id=${this.data.QueueID}&fm=true&color=${this.BGColor.substring(1,7)}`
      }
    },
    created () {
      this.handleLoadComplete = _.debounce(() => {
        this.loading = false
      }, 500)
    },
    mounted () {
      if(this.data.QueueID) this.url = `https://widgets.dviewcontent.com/queue/pharmacy/?id=${this.data.QueueID}&fm=true&color=${this.BGColor.substring(1,7)}`
    },
  }
</script>
<style>
  iframe {
    overflow-x:hidden;
    overflow-y:hidden;
    overflow:hidden;
  }
</style>
